import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import AppShell from "./components/layout/AppShell";
import RecipesPage from "./pages/RecipesPage";
import RecorderPage from "./pages/RecorderPage";
import RunResultsPage from "./pages/RunResultsPage";
import CuttingSimulator from "./pages/CuttingSimulator";
import TVPage from "./pages/TVPage";
import AnomalyReporterPage from "./pages/AnomalyReporterPage";
import ProductionOrdersPage from "./pages/ProductionOrdersPage";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Legacy /dashboards routes redirect to the new TV page */}
          <Route path="/dashboards" element={<Navigate to="/tv" replace />} />
          <Route path="/dashboards/:dashId" element={<Navigate to="/tv" replace />} />
          <Route path="/tv" element={<TVPage />} />
          <Route path="/tv/:profileSlug" element={<TVPage />} />
          <Route element={<AppShell />}>
            <Route path="/" element={<RecipesPage />} />
            <Route path="/recorder" element={<RecorderPage />} />
            <Route path="/recorder/:recipeId" element={<RecorderPage />} />
            <Route path="/runs/:runId" element={<RunResultsPage />} />
            <Route path="/cutting-simulator" element={<CuttingSimulator />} />
            <Route path="/anomalias" element={<AnomalyReporterPage />} />
            <Route path="/ordens-fabrico" element={<ProductionOrdersPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}
